import { useMutation, useQuery, UseQueryOptions } from 'react-query';

import { queryOptions } from '@domains/pdp-common';

import { getPdpSizeInputPage } from '../graphql/pdp-size-input-page.2';
import { GetPdpSizeInputPage, GetPdpSizeInputPageVariables } from '../graphql/pdp-size-input-page_types.2';
import {
  agreeTermAgreement,
  getUserAccountProductMeasurement,
  getUserAccountProductMeasurementList,
  pdpCompareSize,
  setUserAccountProductMeasurement,
} from '../graphql/size-info.2';
import {
  AgreeTermAgreement,
  AgreeTermAgreementVariables,
  GetUserAccountProductMeasurementList,
  PdpCompareSize,
  PdpCompareSizeVariables,
  SetUserAccountProductMeasurement,
  SetUserAccountProductMeasurementVariables,
} from '../graphql/size-info_types.2';

export const PDP_SIZE_INPUT_PAGE_QUERY_KEY = 'getPdpSizeInputPage';
export const USER_ACCOUNT_PRODUCT_MEASUREMENT_QUERY_KEY = 'getUserAccountProductMeasurement';
export const USER_ACCOUNT_PRODUCT_MEASUREMENT_LIST_QUERY_KEY = 'getUserAccountProductMeasurementList';

export const usePdpSizeInputPageQuery = (variables: GetPdpSizeInputPageVariables) => {
  return useQuery<
    { data: GetPdpSizeInputPage },
    unknown,
    { data: GetPdpSizeInputPage },
    [string, GetPdpSizeInputPageVariables]
  >([PDP_SIZE_INPUT_PAGE_QUERY_KEY, variables], () => getPdpSizeInputPage(variables), {
    ...queryOptions,
    enabled: !!variables.size_category_id,
  });
};

export const useGetUserAccountProductMeasurementQuery = (secondary_category_id: string | undefined) => {
  return useQuery(
    [USER_ACCOUNT_PRODUCT_MEASUREMENT_QUERY_KEY, secondary_category_id],
    () => getUserAccountProductMeasurement({ secondary_category_id: secondary_category_id! }),
    {
      ...queryOptions,
      enabled: !!secondary_category_id,
    },
  );
};

export const useGetUserAccountProductMeasurementListQuery = (
  options?: UseQueryOptions<
    { data: GetUserAccountProductMeasurementList },
    unknown,
    { data: GetUserAccountProductMeasurementList },
    string[]
  >,
) => {
  return useQuery([USER_ACCOUNT_PRODUCT_MEASUREMENT_LIST_QUERY_KEY], () => getUserAccountProductMeasurementList(), {
    ...queryOptions,
    ...options,
  });
};

export const useSetUserAccountProductMeasurementMutation = () => {
  return useMutation<
    { data: SetUserAccountProductMeasurement },
    unknown,
    { variables: SetUserAccountProductMeasurementVariables }
  >(async ({ variables }) => {
    return await setUserAccountProductMeasurement(variables);
  });
};

export const usePdpCompareSizeMutation = () => {
  return useMutation<{ data: PdpCompareSize }, unknown, { variables: PdpCompareSizeVariables }>(
    async ({ variables }) => {
      return await pdpCompareSize(variables);
    },
  );
};

export const useAgreeTermAgreementMutation = () => {
  return useMutation<{ data: AgreeTermAgreement }, unknown, { variables: AgreeTermAgreementVariables }>(
    async ({ variables }) => {
      return await agreeTermAgreement(variables);
    },
  );
};
